import {getRequestId} from "../utils";
import {signKBTransactionJWT} from "../../Crypto/utils";
import {AudioModels} from "../../constants";

export const speechToTextWhisperLargeV3API = async (audioUrl, KB, setSystemAlert) => {
    try {
        const modelId = Object.keys(AudioModels)?.find(o => o === "whisperLargeV3");

        const endpoint = AudioModels["whisperLargeV3"]?.url

        let pipeURL = `${endpoint}?audio=${encodeURIComponent(audioUrl)}` + '&requestId=' + getRequestId();

        const transactionJWT = await signKBTransactionJWT({modelId, ...KB, message: 'speech recognition'})
        pipeURL += `&transactionJWT=${encodeURIComponent(transactionJWT)}`;

        let response = await fetch(pipeURL)

        if (response?.status === 499) {
            // handle payment form
        }

        const data = await (response).json();

        if (data?.error) {
            setSystemAlert({msg: data?.error, type: 'error', duration: 3000})
            return;
        }

        return data?.text;
    } catch (error) {
        console.error('speechToTextWhisperLargeV3API request error:', error);
        throw error;
    }
};